module.exports = __webpack_public_path__ + "images/external_images/svg/mockups/laptop-mockup-5.svg";